import { render, staticRenderFns } from "./ColorModuleWelcomeModal.vue?vue&type=template&id=369fe0b3&scoped=true"
import script from "./ColorModuleWelcomeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorModuleWelcomeModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ColorModuleWelcomeModal.vue?vue&type=style&index=0&id=369fe0b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369fe0b3",
  null
  
)

export default component.exports